/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { staffSchema } from "./staffSchema.ts";

export const orgOrganizationStaffListPathOrganizationIdSchema = z.uuid();

export const orgOrganizationStaffListQueryTgIdSchema = z.int().optional();

export const orgOrganizationStaffListStatus200Schema = z.array(staffSchema);

export const orgOrganizationStaffListResponseSchema = orgOrganizationStaffListStatus200Schema;
